<!--
  <AddProductDialog
    :pageName="pageName" // 查询列表（默认不需要，获取B2B商品才需此值）
    :channelId="channelId" // 渠道ID（默认不需要，获取B2B商品才需此值）
    :url="'getB2BChannelCommodity'" // 获取商品URL
    :name="name" // 弹窗名称(默认为商品)
    :leftTitle="columns"   // 左侧表格列
    :rightTitle="columns" // 右侧表格列
    :isMultiple="true" // 是否多选(默认不需要，多选)
    @close="addProduct" // 返回已选商品
  />
-->
<template>
  <!-- 列表穿梭选择 -->
  <div class="add_product">
    <el-dialog
      :close-on-click-modal="false"
      :title="'添加' + name"
      :visible.sync="centerDialogVisible"
      :show-close="showClose"
      width="85%"
      custom-class="add-dialog"
      @open="open"
      @close="close"
    >
      <el-row>
        <el-col class="search-left">
          <el-card>
            <div class="search-top">
              <el-input
                size="mini"
                :placeholder="text"
                clearable
                v-model.trim="inpVal"
                style="width: 200px; margin-right: 20px;"
                @keyup.13.native="getList(1)"
              />
              <DictSelect
                multiple
                type="cml_sample_type"
                placeholder="请选择供应商大类"
                :value="categoryList"
                @change-emit="value => (categoryList = value)"
                style="margin-right: 20px;"
              />
              <el-button size="mini" type="primary" @click="getList(1)">查询</el-button>
              <el-button
                size="mini"
                type="primary"
                v-if="addPromoteRule"
                @click.native="toPromoteRule"
              >新增促销规则</el-button>
              
            </div>
            <div class="search-top-tips" style="color: #f26921;">双击行可以添加至已选列表</div>
            <!-- 左侧选择商品表格 -->
            <el-table
              size="mini"
              v-loading="loading"
              ref="leftTable"
              :data="tableDataLeft"
              style="cursor: pointer;"
              border
              height="400"
              @select="handleSelect"
              @select-all="handleSelectAll"
              @row-dblclick="leftDbClick"
            >
              <!-- <el-table-column type="selection" width="50" /> -->
              <el-table-column type="index" label="序号" width="50" />
              <el-table-column
                show-overflow-tooltip
                v-for="(item, index) in leftTitle"
                :key="index"
                :prop="item.prop"
                :label="item.label"
                :width="item.width ? item.width : ''"
              />
            </el-table>
            <pagination
              style="text-align: right;margin-top: 10px;"
              small
              :showFooterText="false"
              :total="total"
              :page.sync="listQuery.pageNo"
              :limit.sync="listQuery.pageSize"
              @pagination="getList"
            />
          </el-card>
        </el-col>
        <!-- ---------------------- 左右分割线 --------------------->
        <!-- 右侧已选商品列表 -->
        <el-col class="search-right">
          <el-card>
            <div class="search-top search-top-red">已选择{{name}} {{tableDataRight.length}} 条</div>
            <el-table
              size="mini"
              ref="chooseTable"
              :data="tableDataRight"
              border
              height="455"
              :row-class-name="rowClassName"
            >
              <el-table-column type="index" label="序号" width="50" />
              <el-table-column
                show-overflow-tooltip
                v-for="(item, index) in rightTitle"
                :key="index"
                :prop="item.prop"
                :label="item.label"
                :width="item.width ? item.width : ''"
              />
              <!-- 父组件传入-自定义表格列 -->
              <slot></slot>
              <el-table-column label="操作" width="60">
                <template slot-scope="scope">
                  <el-button
                    @click="deleteSelectData(scope)"
                    icon="el-icon-delete-solid"
                    size="mini"
                    type="text"
                  ></el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-card>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="cancel">取消</el-button>
        <el-button size="mini" type="primary" @click="save">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from '@/components/ElementPagination';
import DictSelect from '@/components/DictSelect';

export default {
  name: 'AddProduct',
  components: { Pagination, DictSelect },
  props: {
    page: {
      type: String,
      default: ''
    },
    // 表格左侧列
    leftTitle: {
      type: Array
    },
    // 表格右侧列
    rightTitle: {
      type: Array
    },
    url: {
      // 默认查询接口
      type: String,
      default: 'getSupplierList'
    },
    title: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: undefined
    },
    addPromoteRule: {
      type: Boolean,
      default: false
    },
    channels: {
      type: Array,
      default() {
        return [];
      }
    },
    pageName: {
      type: String,
      default: ''
    },
    channelId: {
      type: String,
      default: ''
    },
    // 是否多选
    isMultiple: {
      type: Boolean,
      default: true
    },
    isJudge: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    name() {
      let name;
      switch (this.title) {
        case 'supplier':
          name = '供应商';
          break;
        default:
          name = '商品';
      }
      return name;
    },
    text() {
      let text;
      switch (this.title) {
        case 'supplier':
          text = '供应商名称';
          break;
        default:
          text = '商品名称/商品编码/条形码';
      }
      return text;
    }
  },
  data() {
    return {
      inpVal: '',
      centerDialogVisible: false,
      tableDataLeft: [],
      tableDataRight: [],
      chooseDataLeft: [],
      chooseDataRight: [],
      total: 0,
      listQuery: {
        pageNo: 1,
        pageSize: 20
      },
      item: {},
      showClose: true,
      loading: false,
      chooseItem: {},
      categoryList: []
    };
  },
  methods: {
    // 双击添加删除数据
    leftDbClick(row) {
      if (!this.isMultiple) {
        this.tableDataRight = [row];
        return false;
      }
      let state = true;
      this.chooseItem = {};
      this.tableDataRight.forEach(item => {
        if (item.customStatus === 'check' && item.id === row.id) {
          state = false;
          this.chooseItem = item;
          this.$message.error('该行数据已经选中！');
        }
      });
      this.$refs.leftTable.toggleRowSelection(row);
      // 新增数据
      if (!state) return;
      this.chooseDataLeft.push(row);
      this.chooseDataLeft = this.uniqueByKey(this.chooseDataLeft, 'id');
      this.tableDataRight = this.chooseDataLeft.map(item => {
        item.customStatus = 'check';
        return item;
      });
    },
    // 设置行样式
    rowClassName({ row }) {
      if (row.id === this.chooseItem.id) {
        return 'commodity-error';
      }
    },
    // 单击选中
    handleSelect(selection, row) {
      let state = true;
      this.tableDataRight.forEach((item, index) => {
        if (item.customStatus === 'check' && item.id === row.id) {
          this.tableDataRight.splice(index, 1); // 删除右侧数据
          state = false;
          this.chooseDataLeft.forEach((item, index) => {
            // 删除左侧数据
            if (item.id === row.id) {
              this.chooseDataLeft.splice(index, 1);
            }
          });
        }
      });
      // 新增数据
      if (!state) return;
      this.chooseDataLeft = this.uniqueByKey(
        [...this.chooseDataLeft, ...selection],
        'id'
      );
      this.tableDataRight = this.chooseDataLeft.map(item => {
        item.customStatus = 'check';
        return item;
      });
    },
    // 全选添加删除
    handleSelectAll(selection) {
      if (selection.length) {
        this.chooseDataLeft = this.uniqueByKey(
          [...this.chooseDataLeft, ...selection],
          'id'
        );
        this.tableDataRight = this.chooseDataLeft.map(item => {
          item.customStatus = 'check';
          return item;
        });
      } else {
        this.tableDataLeft.forEach(item => {
          // 删除数据
          this.tableDataRight.forEach((item2, index) => {
            // 删除右侧数据
            if (item.id === item2.id) {
              this.tableDataRight.splice(index, 1);
            }
          });
          this.chooseDataLeft.forEach((item2, index) => {
            // 删除左侧数据
            if (item.id === item2.id) {
              this.chooseDataLeft.splice(index, 1);
            }
          });
        });
      }
    },
    // 右侧点击删除
    deleteSelectData(scope) {
      let ind = this.tableDataRight.indexOf(scope.row);
      // 删除右侧表格数据
      this.tableDataRight.splice(ind, 1);
      // 左侧所选数据删除
      this.chooseDataLeft.forEach((item, index) => {
        if (item.id === scope.row.id) {
          this.chooseDataLeft.splice(index, 1);
        }
      });
      // 左侧表格去掉勾选
      this.tableDataLeft.forEach(item => {
        if (item.id === scope.row.id) {
          this.$refs.leftTable.toggleRowSelection(item);
          if(this.isJudge) {
            item.earlyMonthNum = '';
            item.lateMonthNum = '';
          }
        }
      });
    },
    // 数组对象去重
    uniqueByKey(arr, key) {
      let hash = {};
      let result = arr.reduce((total, currentValue) => {
        if (!hash[currentValue[key]]) {
          hash[currentValue[key]] = true;
          total.push(currentValue);
        }
        return total;
      }, []);
      return result;
    },
    // 默认查询列表
    getList(val) {
      this.loading = true;
      this.centerDialogVisible = true;
      if (val === 1) this.listQuery.pageNo = 1; // 点击查询设置为第一页
      if (this.url) {
        // 商品基础数据
        let obj = this.listQuery;
        obj.data = {
          name: this.inpVal,
          category: this.type,
          categoryList: this.categoryList
        };
        this.$http.setting[this.url](obj)
          .then(result => {
            this.setTableData(result);
          })
          .catch(err => {
            this.$message.error(err.msg);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    setTableData(result) {
      this.tableDataLeft = result.data.list;
      this.total = result.data.total;

      // 每次切换翻页后选中左侧表格数据
      this.$refs.leftTable.clearSelection();
      this.$nextTick(() => {
        this.tableDataRight.forEach(item => {
          this.tableDataLeft.forEach(item2 => {
            if (item.id === item2.id) {
              this.$refs.leftTable.toggleRowSelection(item2);
            }
          });
        });
      });
    },
    toPromoteRule() {
      this.$store.dispatch('tagsView/clearPage', '');
      this.$store.dispatch('tagsView/changeHeaderMenusList', {
        name: '促销规则',
        href: '/promote-manage/rules'
      });
      this.$router.push({
        name: 'promote-manage/rules',
        params: { from: 'promote-manage/activity' }
      });
      this.centerDialogVisible = false;
    },
    cancel() {
      this.$emit('close', { data: [] });
      this.centerDialogVisible = false;
    },
    save() {
      // 添加商品前时候需要检验
      if(this.isJudge) {
        this.$emit('is-judge', { data: this.tableDataRight });
        return;
      }
      if(this.tableDataRight.length < 1) {
        this.$message.error('请选择'+ this.name);
        return;
      }
      this.$emit('close', { data: this.tableDataRight });
      this.centerDialogVisible = false;
    },
    open() {
      let item = {
        ...this.$store.getters.userSelf.menus.filter(
          item => item.name === '促销规则'
        )[0]
      };
      item.href = '/' + item.href;
      this.item = item;
    },
    close() {
      this.listQuery = { orderBy: '', pageNo: 1, pageSize: 20 }
      this.inpVal = '';
      this.chooseDataLeft = [];
      this.chooseDataRight = [];
      this.tableDataRight = [];
      this.tableDataLeft = [];
      this.$refs.leftTable.clearSelection();
      this.$refs.chooseTable.clearSelection();
    }
  }
};
</script>
<style lang="less">
.add-dialog {
  min-width: 1200px;
}
</style>
<style lang="less" scoped>
.search-top {
  position: relative;
  height: 40px;
  padding: 0 20px 0 0;
}
.search-top-red {
  color: #f26921;
}
.search-left {
  width: 49.5%;
  float: left;
}
.search-top-tips {
  font-size: 12px;
  color: #999;
  vertical-align: middle;
  line-height: 20px;
}
.search-right {
  width: 49.5%;
  float: right;
}
.add_product {
  .el-dialog__body .el-checkbox {
    margin: 0;
  }
}
.routerText {
  text-decoration: none;
  color: #fff;
}
.commodity-error {
  background: #f57c3ced !important;
}
</style>
